export enum CounterColor {
  Primary = 'counter__number--primary',
  Secondary = 'counter__number--secondary',
  BlueDark = 'counter__number--blue-dark',
  GreyDark = 'counter__number--grey-dark',
}
